import React, { useState, useEffect } from "react";
import { MessageSquare } from "lucide-react";
import FeedbackModal from "./FeedbackModal";
import api from "../api/api";

export default function FeedbackButton({ interviewId }) {
  const [open, setOpen] = useState(false);
  const [existingFeedback, setExistingFeedback] = useState(null);

  // Fetch existing feedback
  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const res = await api.get(`/feedback/${interviewId}/mine`);
        setExistingFeedback(res.data);
      } catch (err) {
        // no feedback yet, ignore 404
      }
    };
    if (interviewId) fetchFeedback();
  }, [interviewId]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-5 py-3 rounded-full shadow-lg hover:opacity-90 flex items-center gap-2 transition-all"
      >
        <MessageSquare className="w-5 h-5" />
        {existingFeedback ? "Edit Feedback" : "Give Feedback"}
      </button>

      {open && (
        <FeedbackModal
          interviewId={interviewId}
          existingFeedback={existingFeedback}
          onClose={() => setOpen(false)}
          onSave={(fb) => setExistingFeedback(fb)}
        />
      )}
    </>
  );
}
